import { postRequest, getRequest, deleteRequest } from "../../helpers/request";
// import dayjs from 'dayjs'

export const TYPES = {
  API_REQUEST: "API_REQUEST",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",
  CLEAR_ERROR: "CLEAR_ERROR",

  CREATE_PRESENTATION_SUCCESS: "CREATE_PRESENTATION_SUCCESS",
  UPDATE_PRESENTATION_SUCCESS: "UPDATE_PRESENTATION_SUCCESS",
  LIST_PRESENTATION_SUCCESS: "LIST_PRESENTATION_SUCCESS",
  SHARE_PRESENTATION_SUCCESS: "SHARE_PRESENTATION_SUCCESS",

  CREATE_KEYMESSAGE_SUCCESS: "CREATE_KEYMESSAGE_SUCCESS",
  UPDATE_KEYMESSAGE_SUCCESS: "UPDATE_KEYMESSAGE_SUCCESS",
  LIST_KEYMESSAGE_SUCCESS: "LIST_KEYMESSAGE_SUCCESS",
  UPDATE_BULK_KEYMESSAGE_SUCCESS: "UPDATE_BULK_KEYMESSAGE_SUCCESS",

  DELETE_PRESENTATION: "DELETE_PRESENTATION",
  DELETE_KEYMESSAGE: "DELETE_KEYMESSAGE",

  USER_LIST: "USER_LIST",
  RESET_KM_LOADER: "RESET_KM_LOADER",
};

export const clearError = () => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ERROR });
};

export const apiResponse = (error, msg) => async (dispatch) => {
  dispatch({ type: error ? TYPES.API_ERROR : TYPES.API_SUCCESS, data: msg });
};

export const createPresentation = (formData) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });


  try {
    let response;
    if (formData.pId) {
      response = await postRequest(`presentations/${formData.pId}`, formData, {

        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },

      });
    } else {
      response = await postRequest(`presentations`, formData, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      });
    }

    if (response.data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_PRESENTATION_SUCCESS,
        data: response.data.presentation,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updatePresentation = (pId, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `presentations/${pId}/update`,
      { name: name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_PRESENTATION_SUCCESS,
        data: { pId, name },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const presentationsList = (initialDate, finalDate) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {

    
    // Construct query parameters for the date range
    const queryParams = `?startDate=${initialDate}&endDate=${finalDate}`;

    const { data } = await getRequest(`presentations${queryParams}`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });

    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_PRESENTATION_SUCCESS,
        data: data.presentations,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};


export const createKeyMessage = (formData, id, kmId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let response;
    if (kmId) {
      response = await postRequest(
        `presentations/${id}/key-messages/${kmId}`,
        { name: formData },
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
          },
        }
      );
    } else {
      response = await postRequest(
        `presentations/${id}/key-messages`,
        formData,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    if (response.data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_KEYMESSAGE_SUCCESS,
        data: response.data.keyMessage,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updateKeyMessage = (name, pId, kmId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `presentations/${pId}/key-messages/${kmId}/update`,
      { name: name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_KEYMESSAGE_SUCCESS,
        data: { name, pId, kmId },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const bulkUpdateKeymessage =
  (pId, replaceString, name) => async (dispatch) => {
    dispatch({ type: TYPES.API_REQUEST });
    try {
      const { data } = await postRequest(
        `presentations/${pId}/bulkUpdate`,
        { replaceString: replaceString, updatedName: name },
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
          },
        }
      );

      if (data.isSuccess) {
        dispatch({
          type: TYPES.UPDATE_BULK_KEYMESSAGE_SUCCESS,
          data: data.keyMessage,
        });
      } else {
        dispatch({ type: TYPES.API_ERROR, data: data.msg });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
    }
  };

export const keyMessagesList = (id) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(`presentations/${id}/key-messages`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });
    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_KEYMESSAGE_SUCCESS,
        data: data.keyMessages,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const deletePresentation = (_id, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });

  try {
    const { data } = await deleteRequest(`presentations/${_id}`, {
      data: { name: name },
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });
    if (data.isSuccess) {
      dispatch({ type: TYPES.DELETE_PRESENTATION, data: _id });
    } else {
      console.error(data.msg);

      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const deleteKeyMessage = (_id, kmId, name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await deleteRequest(
      `presentations/${_id}/key-messages/${kmId}`,
      {
        data: { name: name },
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.DELETE_KEYMESSAGE,
        data: { pId: _id, kmId: kmId },
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const createExistingKeyMessage = (formData, pId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let response = await postRequest(
      `presentations/${pId}/key-messages/new`,
      formData,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (response.data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_KEYMESSAGE_SUCCESS,
        data: response.data.keyMessage,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const importExistingKeyMessage = (formData, pId, kmId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let response = await postRequest(
      `presentations/${pId}/key-messages/${kmId}/new`,
      formData,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (response.data.isSuccess) {
      dispatch({ type: TYPES.API_SUCCESS, data: response.data.msg });
      window.location.reload();
    } else {
      dispatch({ type: TYPES.API_ERROR, data: response.data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const getUsersList = () => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(`user/userlist`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });
    if (data.isSuccess) {
      //Added for changing user role and status
      dispatch({
        type: TYPES.USER_LIST,
        data: data.users,
        allRoles: data.allRoles
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const sharePresentation = (pId, uId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `presentations/${pId}/share`,
      { userId: uId },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.SHARE_PRESENTATION_SUCCESS,
        data: { pId, sharedWithData: data.sharedWithData },
        // data: "Shared presenation successfully!!",
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const updateKeyMessageThumb =
  (pId, kmId, formData) => async (dispatch) => {
    dispatch({ type: TYPES.API_REQUEST });
    try {
      const { data } = await postRequest(
        `presentations/${pId}/key-messages/${kmId}/update-thumb`,
        formData,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refreshToken"),
            changeOrigin: true,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (data.isSuccess) {
        dispatch({ type: TYPES.API_SUCCESS, data: "Thumb image is updated" });
        window.location.reload();
      } else {
        dispatch({ type: TYPES.API_ERROR, data: data.msg });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
    }
  };

export const unsetKmLoader = () => async (dispatch) => {
  dispatch({ type: TYPES.RESET_KM_LOADER });
};

export const convertPDFtoHTML = (formData) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    let { data } = await postRequest(`presentations/pdftohtml`, formData, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });

    if (data.isSuccess) {
      dispatch({
        type: TYPES.CREATE_PRESENTATION_SUCCESS,
        msg: data.msg,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};
